module.exports = ".highlight-form {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex; }\n  .highlight-form atn-image-input {\n    margin-right: 20px; }\n  .highlight-form mat-form-field {\n    width: 100%; }\n"


//////////////////
// WEBPACK FOOTER
// ./libs/atenea-cms-brand/src/products/product-highlight-form/product-highlight-form.component.scss
// module id = ./libs/atenea-cms-brand/src/products/product-highlight-form/product-highlight-form.component.scss
// module chunks = main